/// <reference path="../definitions/QueryTs.d.ts" />

/* Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Source: https://github.com/felixge/node-dateformat/blob/master/lib/dateformat.js
 */

interface IDateObject {
    d: number;
    D: number;
    m: number;
    y: number;
    H: number;
    M: number;
    s: number;
    L: number;
    o: number;
}

class QueryDate {
    static __token: RegExp = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g;
    static __timezone: RegExp = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
    static __timezoneClip: RegExp = /[^-+\dA-Z]/g;
    static __dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    static __monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Januari", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

    private _date: Date;
    constructor(date: Date = new Date) {
        if (!(date instanceof Date))
            date = new Date(date);
        
        this._date = date;
    }

    format(mask: string, utc: boolean) {

        let dateObject: IDateObject;
        if (utc) {
            dateObject = {
                d: this._date.getUTCDate(),
                D: this._date.getUTCDay(),
                m: this._date.getUTCMonth(),
                y: this._date.getUTCFullYear(),
                H: this._date.getUTCHours(),
                M: this._date.getUTCMinutes(),
                s: this._date.getUTCSeconds(),
                L: this._date.getUTCMilliseconds(),
                o: 0
            };
        } else {
            dateObject = {
                d: this._date.getDate(),
                D: this._date.getDay(),
                m: this._date.getMonth(),
                y: this._date.getFullYear(),
                H: this._date.getHours(),
                M: this._date.getMinutes(),
                s: this._date.getSeconds(),
                L: this._date.getUTCMilliseconds(),
                o: this._date.getTimezoneOffset()
            };
        }

        let flags: { [index: string]: string }  = {
            d: String(dateObject.d),
            dd: QueryDate.pad(dateObject.d),
            ddd: TRANSLATIONS[QueryDate.__dayNames[dateObject.D + 7]],
            dddd: TRANSLATIONS[QueryDate.__dayNames[dateObject.D]],
            m: String(dateObject.m + 1),
            mm: QueryDate.pad(dateObject.m + 1),
            mmm: TRANSLATIONS[QueryDate.__monthNames[dateObject.m]],
            mmmm: TRANSLATIONS[QueryDate.__monthNames[dateObject.m + 12]],
            yy: String(dateObject.y).slice(2),
            yyyy: String(dateObject.y),
            h: String(dateObject.H % 12 || 12),
            hh: QueryDate.pad(dateObject.H % 12 || 12),
            H: String(dateObject.H),
            HH: QueryDate.pad(dateObject.H),
            M: String(dateObject.M),
            MM: QueryDate.pad(dateObject.M),
            s: String(dateObject.s),
            ss: QueryDate.pad(dateObject.s),
            l: QueryDate.pad(dateObject.L, 3),
            L: QueryDate.pad(Math.round(dateObject.L / 10)),
            t: dateObject.H < 12 ? "a" : "p",
            tt: dateObject.H < 12 ? "am" : "pm",
            T: dateObject.H < 12 ? "A" : "P",
            TT: dateObject.H < 12 ? "AM" : "PM",
            Z: utc ? 'UTC' : ((String(this._date).match(QueryDate.__timezone) || ['']).pop() || "").replace(QueryDate.__timezoneClip, ''),
            o: (dateObject.o > 0 ? '-' : '+') + QueryDate.pad(Math.floor(Math.abs(dateObject.o) / 60) * 100 + Math.abs(dateObject.o) % 60, 4)
        };

        return mask.replace(QueryDate.__token, function (match) {
            if (match in flags) {
                return flags[match];
            }
            return match.slice(1, match.length - 1);
        });
    }

    static pad(val: number, length: number = 2) {
        let strVal = String(val);
        while (strVal.length < length) {
            strVal = '0' + strVal;
        }
        return strVal;
    }
}